namespace GeniuzPOS.Purchase {
    export interface PoPo06PendingCNforCnrtvForm {
        SysDocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        SupplierId: Serenity.LookupEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        ShipId: Serenity.StringEditor;
        ShipDate: Serenity.DateEditor;
        WhsId: Serenity.StringEditor;
        DtList: PoPo06DtPendingCNforCnrtvEditor;
        Remark: Serenity.StringEditor;
        ReceiptAmt: Serenity.DecimalEditor;
        PayTermCode: Serenity.StringEditor;
    }

    export class PoPo06PendingCNforCnrtvForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPo06PendingCNforCnrtv';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoPo06PendingCNforCnrtvForm.init)  {
                PoPo06PendingCNforCnrtvForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = PoPo06DtPendingCNforCnrtvEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(PoPo06PendingCNforCnrtvForm, [
                    'SysDocNo', w0,
                    'DocDate', w1,
                    'SupplierId', w2,
                    'RefDocNo1', w0,
                    'RefDocNo2', w0,
                    'ShipId', w0,
                    'ShipDate', w1,
                    'WhsId', w0,
                    'DtList', w3,
                    'Remark', w0,
                    'ReceiptAmt', w4,
                    'PayTermCode', w0
                ]);
            }
        }
    }
}
